

var __products_original;
function getAllProducts(){
  $.ajax({
    url : "/products.json?limit=999",
    type: "GET",
    success: function(data, textStatus, jqXHR){
      __products_original = {};
      for( var key in data["products"] ){
        let data_product = data["products"][key];
        let id = data_product["id"];
        __products_original[id] = data_product;
        console.log(data_product);
      }
    console.log("PRODUCTS SYNC");
      //Trigger:
      var event = new CustomEvent("getAllProductsFinish", {detail: null});
      window.dispatchEvent(event);
    },
    error: function (jqXHR, textStatus, errorThrown){}
  });
}
function addonProductSectionToggle(obj){
  _bundles.addon_popup_manually = true;
  // let addon_section = $(obj).closest(".add_these_to_your_bundle_container").find(".addintional_product_container");
  // $(addon_section).slideToggle();
  // $(obj).closest(".add_these_to_your_bundle_container").find(".close_container").toggleClass("opened");
}

function addonProductSectionToggles(op){
  if( op ){
    if( _bundles.addon_auto_open ){
      $(".add_these_to_your_bundle_container").find(".addintional_product_container").slideDown();
      $(".add_these_to_your_bundle_container").find(".close_container").addClass("opened");
    }
  }
  else{
    $(".add_these_to_your_bundle_container").find(".addintional_product_container").slideUp();
    $(".add_these_to_your_bundle_container").find(".close_container").removeClass("opened");
  }
}

        
(function() {
  var config = _bundles;

  function addItemToCart(p_options) {
    var data = {
      quantity: p_options.quantity,
      id: p_options.variant_id,
    };

    if (p_options.properties !== undefined) {
      data['properties'] = p_options.properties
    }
    console.log(data);

    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function(data) { 
          resolve(data);
        },
        error: function(error) { 
          reject(error);
        }
      });
    });
  }

  function addItemsToCart(p_options) {
    async.eachSeries(p_options.items, function(item, callback) {
      addItemToCart(item)
      .then(function() {
        callback();
      })
    }, function(err) {
      if (err) {
        console.log(err);
      }

      // After all done
      p_options.callback();
    });
  }

  function getCartJSON() {
    return new Promise(function(resolve, reject) {
      $.getJSON('/cart.js', function(data) {
        resolve(data);
      });
    });
  }
  
  function createDraftOrder(items) {
    var order = {
      line_items: [
        {
          title: 'Custom Product',
          price: '20.00',
          quantity: 1
        }
      ]
    };
    var app_url = 'https://aaf61db5.ngrok.io';

    _.each(items, function(item) {
      order.line_items.push({
        variant_id: item.variants[0].id,
        quantity: 1
      })
    });
    console.log(order);
    
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: app_url + '/create-order',
        data: {
          shop_url: Shopify.shop,
          order: order,
          order_type: 'order'
        },
        dataType: 'json',
        success: function(data) { 
          console.log(data);
          resolve(data);
        },
        error: function(error) { 
          console.error(error);
        },
      });      
    });
  }
  
  function updateCart(p_options) {
    var updates = {};
    updates[p_options.variant_id] = p_options.quantity;
    
    return new Promise(function(resolve, reject) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {updates: updates},
        success: function(data) {
          resolve(data);
        },
        ajax: true,
        dataType: 'json'
      });
    });
  }

  function uniqId() {
    return Math.random().toString(36).substr(2, 9);
  }
  
  function getItemsCache() {
    var cache = JSON.parse(localStorage.getItem('bundle')) || {bundle: []};
    return cache.bundle;
  }
  
  function getDiscountValue(bundle, product,obj) {
    //var itemsCount = bundle.length;
    var itemsCount = obj.normalBundleCount();
    var discount = 0;

    // Free item, discount = 100%
    var isFreeItem = product.variants[0].id == config.free_item.variants[0].id;
    if (isFreeItem) {
      discount = config.free_item.variants[0].price;
      return discount;
    }
    
    // Free gift item, discount = 100%
    if( config.free_gift_item!=undefined ){
      var isFreeGiftItem = product.variants[0].id == config.free_gift_item.variants[0].id;
      if (isFreeGiftItem) {
        discount = config.free_gift_item.variants[0].price;
        return discount;
      }
    }
    
    //Carrying case product or sleeve (special), no discount
    if( product.is_hidden ){
      return 0;
    }
    
    // 3+ items, discount = 3%
    switch(itemsCount) {
      case 0:
        discount = 0; break;
      case 1:
        discount = 0; break;
      case 2:
        discount = 0; break;
      default:
        discount = product.variants[0].price * 0.03; 
        break;
    }
    return discount;
  }

  var app = new Vue({
    el: '#app',
    data: {
      bundleOption: false,
      products: config.products,
      bundle: getItemsCache(),
      minItems: config.minItems,
      maxItems: config.maxItems,
      freeItemStand: 0,
      freeItemSecret: 0,
      subtotal: 0,
      subtotal_discounted: 0
    },
    
    computed: {
      isBundleValid: function() {
        var _self = this;
        //console.log(this.bundle.length, config.minItems, config.maxItems);
        //return _self.bundle.length >= config.minItems && _self.bundle.length <= config.maxItems;
        let count = _self.normalBundleCount();
        return count >= config.minItems && count <= config.maxItems;
      }
      
    },
    
    
    
    mounted: function () {
      //Prepar to render tags
      if( __products_original==null ){
        var that = this;
        window.addEventListener('getAllProductsFinish', function(e){
          that.renderTags();
        }, false);
        getAllProducts();
      }
      else this.renderTags();
      
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been rendered
        this.updateTotal();
        
      });
      
      
      if( window.screen.width < 1024 ){
        $("#app").find('.product-images__slider').flickity({
          // options
          autoPlay: false,
          setGallerySize: true,
          wrapAround: true,
          adaptiveHeight: true,
          //setGallerySize: true,
          imagesLoaded: true,
          lazyLoad: true,
          pageDots: false,
          prevNextButtons: true,
          arrowShape: { 
            x0: 0,
            x1: 45, y1: 50,
            x2: 50, y2: 50,
            x3: 5
          }
          //friction: 1,
          //selectedAttraction: 0.2
        });
        
        var _lazyload = 4;
        if( window.screen.width < 1024 ) _lazyload = 8;

        $("#app").find('.product-images__thumbs').each(function(){
          let parent_id = $(this).closest(".sliders_container").attr("data-id");
          let mainslider_id_str = "slider_main_"+parent_id;
          
          $(this).flickity({
            // options
            autoPlay: false,
            wrapAround: true,
            contain: true,
            adaptiveHeight: true,
            setGallerySize: true,
            imagesLoaded: true,
            //lazyLoad: true,
            lazyLoad: _lazyload,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            friction: 1,
            asNavFor: '#'+mainslider_id_str,
            //groupCells:'100%'
            //selectedAttraction: 0.2
          });
        });
        
      }
      
      var ids = getParameterByName('dataprod');
      if( ids ){
        let ids_array = ids.split(",");
        for( let key in ids_array ){
          let id = ids_array[key];
          $('button#'+id).trigger('click');
          
        }
        //Remove the parameter
        let new_url = window.location.href.substring(0, window.location.href.indexOf('?dataprod'));
        if (window.history.replaceState) {
          //prevents browser from storing history with each change:
          window.history.replaceState({}, "Bundle", new_url);
        }
      }
      
      
      if( config.addon_default_close ) $(".addintional_product_container").hide();
      if( !config.addon_auto_open ) $(".addintional_product_container").hide();
      
      
      
    },
    
    methods: {
      renderTags: function(){
        //Render tags
        for( let key in __bundle_products ){
          let bundle_product = __bundle_products[key];
          let bundle_handle = bundle_product["handle"];
          let id = bundle_product["id"];
          if( typeof __products_original[id] == "undefined" ) continue;
          let tags = __products_original[id]["tags"];
          for( let key_tag in __products_original[id]["tags"] ){
            let tag = __products_original[id]["tags"][key_tag];
            if( tag=="sold out" || tag=="surface" ) continue;

            $("div[data-handle='"+bundle_handle+"'] > .image > div").each(function(){
              $(this).append('<div class="tag_new tag_rectangle"><span>'+tag+'</span></div>');
            });
          }
        }
      },
      
      
      
      specialProductAdded: function(id){
        for( let key in this.bundle ){
          let item = this.bundle[key];
          if( item.id==id ) return true;
        }
        return false;
      },
      
      normalBundleCount: function(){
        var _self = this;
        let count = 0;
        for( let key in _self.bundle ){
          //if( _self.bundle[key].is_hidden_on_bundle_list ) count++; //Count those add-on products
          //else if( !_self.bundle[key].is_hidden ) count++;  //Count normal products
          if( !_self.bundle[key].is_hidden ) count++; //Count normal products
        }
        return count;
      },
      
      specialBundleCountAll: function(){
        var _self = this;
        let count = 0;
        for( let key in _self.bundle ){
          if( _self.bundle[key].is_hidden ) count++;
        }
        return count;
      },
      
      specialBundleCount: function(name){
        var _self = this;
        let count = 0;
        for( let key in _self.bundle ){
          if( _self.bundle[key].is_hidden && _self.bundle[key].name==name ) count++;
        }
        return count;
      },
      
      subtotalCount: function(){
        var _self = this;
        let count = 0;
        for( let key in _self.bundle ){
          if( _self.bundle[key].is_hidden_on_bundle_list ) count++; //Count those add-on products
          else if( !_self.bundle[key].is_hidden ) count++;  //Count normal products
        }
        return count;
      },
      
      getShopifyImageWithDimension: function(url,dimension,for_set){
        let dot_index = url.lastIndexOf(".");
        let part1 = url.substr(0,dot_index);
        let part2 = url.substr(dot_index);
        let new_url = part1+"_"+dimension+"x"+part2;
        if( for_set ) return new_url+" "+dimension+"w "+dimension+"h";
        else return new_url;
      },
      
    
      updateTotal: function() {
  var _self = this;
  var total = 0, total_discounted = 0;
  
  _self.freeItemStand = 0;
  _self.freeItemSecret = 0;
  
  _.each(_self.bundle.concat(config.free_item), function(product) {
    var quantity = 1;
    
    var isFreeGiftItem = false;
    var isFreeItem = product.variants[0].id == config.free_item.variants[0].id;
    if( config.free_gift_item != undefined ) isFreeGiftItem = product.variants[0].id == config.free_gift_item.variants[0].id;

    // Comment out the following block to disable adding free items based on bundle count
    /*
    if (isFreeItem && _self.normalBundleCount() >= 5) {
      quantity = 2;
      _self.freeItemStand = 1;
      _self.freeItemSecret = 1;
    }
    else if (isFreeGiftItem && _self.normalBundleCount() >= 4) {
      quantity = 1;
      _self.freeItemStand = 1;
    }
    else {
      quantity = 1;
    }
    */
    
    total += product.price * quantity;
    total_discounted += product.price - getDiscountValue(_self.bundle, product,_self);
  });

  _self.subtotal_discounted = total_discounted;
  _self.subtotal = total;
  
  if( this.bundle.length > 0 ) {
    $(".add_these_to_your_bundle_container").show();
    if( !config.addon_popup_manually ) {
      addonProductSectionToggles(true);
    }
  }
  else {
    $(".add_these_to_your_bundle_container").hide();
    //addonProductSectionToggles(false);
  }
},


      configureBundle: function(id) {
        var _self = this;        
        _self.bundleOption = id;
      },
      
      getBundleProduct: function(product_id) {
        let product = null;
        for( let key in __bundle_products ){
          let current_product = __bundle_products[key];
          if( current_product.id==product_id ){
            product = current_product;
            break;
          }
        }
        return product;
      },
      
      
      addSpecialItemsToBundle: function(var_name) {
        let obj = eval('__BPM_'+var_name);
        //console.log( obj.qty );
        if( obj.product_id=="" || obj.qty<=0 ) return;
        let bundle_product = this.getBundleProduct(__BPM_1.product_id);
        if( bundle_product==null ){
          console.log("special product not exist!");
          return;
        }
        let qty = obj.qty;
        for(let i=0;i<qty;i++){
          let current_count = this.specialBundleCount(obj.name);
          let remains = obj.inventory_quantity - current_count;
          if( remains>0 ) this.addItemToBundle(obj.product_id);
        }
        //console.log($("#add-on-product-"+var_name).find(".image_container").find(".added").length);
        //console.log(var_name);
        $(".add-on-product-"+var_name).addClass("adding");
        $(".add-on-product-"+var_name).find(".image_container").find(".added").fadeIn( "slow", function() {
          // Animation complete.
          $(this).delay(500).fadeOut("slow",function() {
            $(this).closest(".product").find(".icon_added").show();
            $(".add-on-product-"+var_name).removeClass("adding");
          });
          $(this).closest(".product").find(".icon_added").show();
          $(".add-on-product-"+var_name).removeClass("adding");
        });
      },
      
        
      addItemToBundle: function(product_id) {
        var _self = this;
        var selectedProduct = _.filter(_self.products, function(product) {
          return product.id == product_id;
        })[0];
        //console.log(selectedProduct);
        

        //if (!_.isUndefined(selectedProduct) && _self.normalBundleCount()<=(config.maxItems-1) ) {
        if (!_.isUndefined(selectedProduct) ) {
          selectedProduct.inventory_quantity--;
          _self.bundle.push(selectedProduct);
          
          _self.addItemToCache(selectedProduct);
        }

        _self.updateTotal();
      },
      
      removeItemFromBundleByProductID: function(id,var_name) {
        //var _self = this;
        //let tmp_product = _self.bundle.splice(index, 1);
        let new_bundle = [];
        let index = 0;
        for( let key in this.bundle ){
          let current_bundle = this.bundle[key];
          if( current_bundle["id"]!=id ) new_bundle.push(current_bundle);
        }
        this.bundle = new_bundle;
        
        this.updateTotal();
        this.saveItemCache();
        
        $(".add-on-product-"+var_name).find(".image_container").find(".removed").fadeIn( "slow", function() {
          $(this).delay(500).fadeOut("slow",function() {
          });
        });
      },
      
      removeItemFromBundle: function(index) {
        var _self = this;
        let tmp_product = _self.bundle.splice(index, 1);
        _self.updateTotal();
        
        _self.removeItemFromCache(index);
      },
      
      clearBundle: function() {
        var _self = this;
        //_self.bundle = [];
        //_self.updateTotal();
        
        _self.clearBundleCache();
      },
      
      addItemToCache: function(product_id) {
        var _self = this;
        var cache = JSON.parse(localStorage.getItem('bundle')) || {bundle: []};
        cache.bundle.push(product_id);
        localStorage.setItem('bundle', JSON.stringify(cache));
      },      
      
      removeItemFromCache: function(index) {
        var _self = this;
        var cache = JSON.parse(localStorage.getItem('bundle')) || {bundle: []};
        cache.bundle.splice(index, 1);
        localStorage.setItem('bundle', JSON.stringify(cache));
      },   
      
      saveItemCache: function() {
        var cache = JSON.parse(localStorage.getItem('bundle')) || {bundle: []};
        cache.bundle = this.bundle;
        localStorage.setItem('bundle', JSON.stringify(cache));
      },
      
      clearBundleCache: function() {
        var _self = this;
        var cache = JSON.parse(localStorage.getItem('bundle')) || {bundle: []};
        cache.bundle = [];
        localStorage.setItem('bundle', JSON.stringify(cache));
      },
      
      addBundleToCart: function() {
        var _self = this;
        var bundleUniqId = uniqId();
        var bundleItems = _self.bundle.concat(config.free_item);
        if( config.free_gift_item!=undefined ) bundleItems = bundleItems.concat(config.free_gift_item);

        
        var items = _.map(bundleItems, function(product) {
          var variant_id = product.variants[0].id;
          var quantity = 1;
          
          var isFreeItem = product.variants[0].id == config.free_item.variants[0].id;
          if (isFreeItem && _self.normalBundleCount() >= 5) {
            quantity = 2;
          }
          
          if( config.free_gift_item!=undefined ){
            var isFreeGiftItem = product.variants[0].id == config.free_gift_item.variants[0].id;
            if ( isFreeGiftItem ) {
              if( _self.normalBundleCount() >= 4 ) quantity = 1;
              else quantity = 0;
            }
          }
          
          if( __bundle_addon_products.includes(product.id) ){
            //Excludes those addon products to bundle
            return {
              variant_id: variant_id,
              quantity: quantity
            }
          }
          else{
            return {
              variant_id: variant_id,
              quantity: quantity,
              properties: {
                '_bundle': bundleUniqId,
                '_discount': getDiscountValue(_self.bundle, product,_self)
              }
            }
          }
        });
        //console.log(items);
        //return;
        
        $('.add-bundle-btn').addClass('btn--loading');
        
        addItemsToCart({
          items: items,
          callback: function() {
            $('.add-bundle-btn').removeClass('btn--loading');
            //refreshCart();
            _self.clearBundle();
            
            window.location.href = '/checkout';
          }
        })
      },
      
      addBundleToCartTEST: function() {
        createDraftOrder(this.bundle);
      }
    },

    filters: {
      money: function(value) {
        return '$' + parseFloat(value/100).toFixed(2);
      },

      unhandleize: function(value) {
        return value.replace('-', ' ');
      }
    }
  });
  
  //app_vue = app;
  
  function playVideo() {
    var video = document.querySelector('.video-container video');
    video.addEventListener('canplay', function() {
      //video.play();
    });
  }
  
  // Document on ready
  document.addEventListener('DOMContentLoaded', function() {});
})();